__turbopack_context__.v({
  "iconWrapper": "NavQuickLinkItem-module-scss-module__7ZAXJW__iconWrapper",
  "img": "NavQuickLinkItem-module-scss-module__7ZAXJW__img",
  "imgBox": "NavQuickLinkItem-module-scss-module__7ZAXJW__imgBox",
  "label": "NavQuickLinkItem-module-scss-module__7ZAXJW__label",
  "linkButton": "NavQuickLinkItem-module-scss-module__7ZAXJW__linkButton",
  "linkButtonIcon": "NavQuickLinkItem-module-scss-module__7ZAXJW__linkButtonIcon",
  "linkButtonText": "NavQuickLinkItem-module-scss-module__7ZAXJW__linkButtonText",
  "linkButtonWrapper": "NavQuickLinkItem-module-scss-module__7ZAXJW__linkButtonWrapper",
  "selected": "NavQuickLinkItem-module-scss-module__7ZAXJW__selected",
  "svgImage": "NavQuickLinkItem-module-scss-module__7ZAXJW__svgImage",
  "wrapper": "NavQuickLinkItem-module-scss-module__7ZAXJW__wrapper",
});
